import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ArrowRight, CheckCircle2 } from 'lucide-react';

const Hero = () => {
  const { t } = useLanguage();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-gray-50 via-blue-50/30 to-gray-100">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiMxYzM4NTUiIGZpbGwtb3BhY2l0eT0iMC4wMyI+PHBhdGggZD0iTTM2IDEzNGg4djhIMzZ6bTAgMThoOHY4SDM2em0wIDE4aDh2OEgzNnptMCAxOGg4djhIMzZ6bTAtNzJoOHY4SDM2em0xOCAwaDh2OGgtOHptMCAxOGg4djhoLTh6bTAgMThoOHY4aC04em0wIDE4aDh2OGgtOHptMC03Mmg4djhoLTh6bTM2IDcyaDh2OGgtOHptMCAxOGg4djhoLTh6bTAgMThoOHY4aC04em0wIDE4aDh2OGgtOHptMC03Mmg4djhoLTh6bTE4IDBoOHY4aC04em0wIDE4aDh2OGgtOHptMCAxOGg4djhoLTh6bTAgMThoOHY4aC04em0wLTcyaDh2OGgtOHoiLz48L2c+PC9nPjwvc3ZnPg==')] opacity-40"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full border border-[#1c3855]/20 mb-8 shadow-sm">
            <CheckCircle2 className="h-4 w-4 text-[#1c3855]" />
            <span className="text-sm font-medium text-[#1c3855]">
              Canon Colorado Technology • 5-Day Production
            </span>
          </div>

          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 leading-tight">
            {t.hero.title.split(' ').map((word, idx) => {
              if (word === 'Wall' || word === 'Art' || word === 'Business' || word === 'İşinizi' || word === 'Бизнес') {
                return (
                  <span key={idx} className="text-[#1c3855]">
                    {word}{' '}
                  </span>
                );
              }
              return <span key={idx}>{word} </span>;
            })}
          </h1>

          <p className="text-xl sm:text-2xl text-gray-600 mb-12 leading-relaxed max-w-3xl mx-auto">
            {t.hero.subtitle}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={() => scrollToSection('contact')}
              className="group bg-[#1c3855] text-white px-8 py-4 rounded-xl hover:bg-[#152d44] transition-all duration-300 font-semibold text-lg shadow-lg hover:shadow-xl hover:scale-105 flex items-center gap-2"
            >
              {t.hero.primaryCTA}
              <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              onClick={() => scrollToSection('capabilities')}
              className="group bg-white text-[#1c3855] px-8 py-4 rounded-xl border-2 border-[#1c3855] hover:bg-[#1c3855] hover:text-white transition-all duration-300 font-semibold text-lg shadow-md hover:shadow-lg hover:scale-105"
            >
              {t.hero.secondaryCTA}
            </button>
          </div>

          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-3xl mx-auto">
            {[
              { number: '5', label: 'Days Production', labelTr: 'Gün Üretim', labelRu: 'Дней Производство' },
              { number: '99.8%', label: 'Quality Rate', labelTr: 'Kalite Oranı', labelRu: 'Качество' },
              { number: '24/7', label: 'Support', labelTr: 'Destek', labelRu: 'Поддержка' },
              { number: '100+', label: 'Partners', labelTr: 'Ortak', labelRu: 'Партнеры' }
            ].map((stat, idx) => (
              <div key={idx} className="bg-white/60 backdrop-blur-sm rounded-2xl p-6 border border-[#1c3855]/10 shadow-sm hover:shadow-md transition-shadow">
                <div className="text-3xl font-bold text-[#1c3855] mb-2">{stat.number}</div>
                <div className="text-sm text-gray-600 font-medium">
                  {t.hero.title.includes('İş') ? stat.labelTr : t.hero.title.includes('Бизнес') ? stat.labelRu : stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
